import * as React from 'react';
import Card from './Card';
import { ActionButton } from './ActionButtons';
import '../css/collapse-panel.sass';
import CampfireButton from './CampfireButton';

interface PanelActionButton {
  button: ActionButton;
  content: React.ReactNode;
}

interface CollapsePanelProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  buttons: PanelActionButton[];
  restoreButton: ActionButton;
  onExpand?: Function;
}

export default function CollapsePanel(props: CollapsePanelProps) {
  const [expandedDetailsIndex, setExpandedDetailsIndex] = React.useState<
    number
  >(-1);

  const ref: any = React.useRef();

  const onRestore = () =>
    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  let keyIndex = 0;
  return (
    <div className="collapse-panel" ref={ref}>
      <Card>
        {props.title}
        {props.description && (
          <div className="description">{props.description}</div>
        )}
        <div className="panelButtons">
          {props.buttons.map(
            (panelActionBtn: PanelActionButton, index: number) => {
              keyIndex += 1;
              return (
                <React.Fragment
                  key={`${panelActionBtn.button.label
                    .toLowerCase()
                    .replace(' ', '')}-${keyIndex}`}
                >
                  {(expandedDetailsIndex === -1 ||
                    expandedDetailsIndex === index) && (
                    <CampfireButton
                      name={`${panelActionBtn.button.label
                        .toLowerCase()
                        .replace(/[^\w]/g, '')}-btn`}
                      id={`${panelActionBtn.button.label
                        .toLowerCase()
                        .replace(/[^\w]/g, '')}-btn`}
                      frosty={
                        !panelActionBtn.button.type ||
                        panelActionBtn.button.type === 'secondary'
                      }
                      ghost={
                        !panelActionBtn.button.type ||
                        panelActionBtn.button.type === 'secondary'
                      }
                      ariaExpanded={expandedDetailsIndex === index}
                      {...panelActionBtn.button}
                      onClick={() => {
                        if (expandedDetailsIndex === -1)
                          setExpandedDetailsIndex(index);
                        else setExpandedDetailsIndex(-1);
                        if (props.onExpand)
                          props.onExpand(expandedDetailsIndex === -1, index);
                      }}
                    />
                  )}
                </React.Fragment>
              );
            }
          )}
        </div>
        {expandedDetailsIndex > -1 && (
          <>
            <div className="content">
              {props.buttons[expandedDetailsIndex].content}
            </div>
            <div className="restoreButton">
              <CampfireButton
                name={`${props.restoreButton.label}`}
                id={`${props.restoreButton.label}`}
                {...props.restoreButton}
                ghost
                onClick={() => {
                  onRestore();
                  setExpandedDetailsIndex(-1);
                  if (props.onExpand)
                    props.onExpand(false, expandedDetailsIndex);
                }}
              />
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
